import { render } from "./Cams.vue?vue&type=template&id=2e219250&scoped=true"
import script from "./Cams.vue?vue&type=script&lang=js"
export * from "./Cams.vue?vue&type=script&lang=js"

import "./Cams.vue?vue&type=style&index=0&id=2e219250&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e219250"]])

export default __exports__